"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoyaltyEditDialog = exports.royaltyFormValidationSchema = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_mask_1 = require("@dzambalaorg/mui-inputs-mask");
var validation_1 = require("./validation");
Object.defineProperty(exports, "royaltyFormValidationSchema", { enumerable: true, get: function () { return validation_1.royaltyFormValidationSchema; } });
const RoyaltyEditDialog = () => {
    return (0, jsx_runtime_1.jsx)(mui_inputs_mask_1.CurrencyInput, { name: "royalty", symbol: "%", required: true });
};
exports.RoyaltyEditDialog = RoyaltyEditDialog;
//# sourceMappingURL=index.js.map